"use client";

import NavMenu from "./menu/NavMenu";
import React, { useEffect, useState } from "react";
import Offcanvas2 from "@/components/common/Offcanvas2";

import UseThemeCheck from "@/hooks/UseThemeCheck";
import { scroller, animateScroll } from "react-scroll";
import { Icon } from "@/svg/Icon";

const MuseHeader = () => {
  const [showCanvas, setShowCanvas] = useState<boolean>(false);
  const { active, toggleTheme } = UseThemeCheck();

  const scrollToTop = () => {
    animateScroll.scrollToTop();
  };

  const handleScrollClick = () => {
    scroller.scrollTo("about-info-area", {
      duration: 800,
      delay: 0,
      smooth: "easeInOutQuart",
    });
    return false;
  };

  // sticky header
  const [lastScrollTop, setLastScrollTop] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollTop = window.scrollY;

      if (currentScrollTop > lastScrollTop) {
        document
          .querySelector(".tp-int-menu")
          ?.classList.remove("tp-header-pinned");
      } else if (currentScrollTop <= 500) {
        document
          .querySelector(".tp-int-menu")
          ?.classList.remove("tp-header-pinned");
      } else {
        document
          .querySelector(".tp-int-menu")
          ?.classList.add("tp-header-pinned");
      }
      setLastScrollTop(currentScrollTop);
    };
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollTop]);

  return (
    <>
      <header>
        <div className="tp-header-4__area tp-header-mob-space tp-header-transparent p-relative">
          {/* <span className="tp-header-border"></span> */}
          <div className="container container-large">
            <div className="row align-items-center">
              <div className="col-xl-2 col-lg-5 col-md-5 col-6">
                <div className="logo">
                  <a onClick={scrollToTop}>
                    <Icon name="LogoMuseHorizontal" width="115px" />
                  </a>
                </div>
              </div>
              <div className="col-xl-9 d-none d-xl-block">
                <div className="main-menu">
                  <nav className="tp-main-menu-content">
                    <NavMenu />
                  </nav>
                </div>
              </div>

              <div className="col-xl-1 col-lg-7 col-md-7 col-6">
                <div className="tp-header-right d-flex align-items-center justify-content-end">
                  <div className="tp-theme-toggle">
                    <label
                      className="tp-theme-toggle-main themepure-theme-toggle"
                      htmlFor="this-s"
                    >
                      <span className=" tp-theme-toggle-light">
                        <Icon name="Sun" />
                      </span>

                      <input
                        type="checkbox"
                        className="themepure-theme-toggle-input"
                        id="this-s"
                      />

                      <i className="tp-theme-toggle-slide"></i>

                      <span className="tp-theme-toggle-dark">
                        <Icon name="Moon" />
                      </span>
                    </label>
                  </div>

                  <div className="tp-header-hamburger ml-20 d-block d-xl-none">
                    <button
                      className="tp-hamburger-btn tp-hamburger-btn-white tp-menu-bar tp-offcanvas-open-btn-2"
                      onClick={() => setShowCanvas(true)}
                      type="button"
                    >
                      <span></span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <header>
        <div className="tp-header-4__area tp-header-mob-space tp-header-transparent p-relative tp-int-menu tp-header-sticky-cloned">
          <div className="container container-large">
            <div className="row align-items-center">
              <div className="col-xl-2 col-lg-5 col-md-5 col-6">
                <div className="logo">
                  <a onClick={scrollToTop}>
                    <Icon name="LogoMuseHorizontal" width="115px" />
                  </a>
                </div>
              </div>
              <div className="col-xl-9 d-none d-xl-block">
                <div className="main-menu">
                  <nav className="tp-main-menu-content">
                    <NavMenu />
                  </nav>
                </div>
              </div>
              <div className="col-xl-1 col-lg-7 col-md-7 col-6">
                <div className="tp-header-right d-flex align-items-center justify-content-end">
                  <div className="tp-theme-toggle ">
                    <label
                      defaultChecked={active}
                      onChange={toggleTheme}
                      className={`tp-theme-toggle-main themepure-theme-toggle  ${
                        active ? "dark-active" : "light-active"
                      }`}
                      htmlFor="this-ss"
                    >
                      <span
                        id="tp-theme-toggle-light"
                        className=" tp-theme-toggle-light"
                      >
                        <Icon name="Sun" />
                      </span>

                      <input
                        id="this-ss"
                        type="checkbox"
                        className="themepure-theme-toggle-input"
                      />

                      <i className="tp-theme-toggle-slide"></i>

                      <span
                        id="tp-theme-toggle-dark"
                        className="tp-theme-toggle-dark"
                      >
                        <Icon name="Moon" />
                      </span>
                    </label>
                  </div>

                  <div className="tp-header-hamburger ml-20 d-block d-xl-none">
                    <button
                      onClick={() => setShowCanvas(true)}
                      className="tp-hamburger-btn tp-hamburger-btn-white tp-menu-bar tp-offcanvas-open-btn-2"
                      type="button"
                    >
                      <span></span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <Offcanvas2 showCanvas={showCanvas} setShowCanvas={setShowCanvas} />
    </>
  );
};

export default MuseHeader;
